exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Footer-module__footerContainer--5ioeR{\r\n    text-align: center;\r\n    display: flex;\r\n    justify-content: center;\r\n    flex-direction: column;\r\n    position: absolute;\r\n    bottom: 0;\r\n    width: 100%;\r\n    height: 24px;\r\n    background-color: #ffffff;\r\n    font-family: Noto Sans KR;\r\n    font-size: 12px;\r\n    font-weight: 500;\r\n    font-style: normal;\r\n    font-stretch: normal;\r\n    line-height: normal;\r\n    letter-spacing: normal;\r\n    color: #333333;\r\n    cursor: pointer;\r\n    z-index: 3;\r\n}\r\n\r\n", ""]);

// exports
exports.locals = {
	"footerContainer": "Footer-module__footerContainer--5ioeR"
};